<form class="form" (ngSubmit) = "onSubmit()">
    <input type="text" name = "comment" [(ngModel)] = "comment" placeholder="comment">
    <input type="submit" value="submit" class="btn">
</form>

